import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const saveSettings = (data) => api.put("/settings", data).then((r) => r.data);
export const testConnection = () => api.post("/test-connection").then((r) => r.data);
export const sendTest = (to_email) => api.post("/send-test", { to_email }).then((r) => r.data);
export const sendEmail = (data) => api.post("/send", data).then((r) => r.data);
export const listCampaigns = () => api.get("/campaigns").then((r) => r.data);
export const getCampaign = (id) => api.get(`/campaigns/${id}`).then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
